if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const recipientForm = this.form.querySelector('recipient-form');

        if (recipientForm) {
          const valid = this.validateRecipientForm(recipientForm);

          if (!valid) return;
        }

        const cartItems = this.closest('main').querySelector('cart-items');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          console.log('Adding sections to cart request');
          console.log(window.location.pathname);
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let warrantyFormData = null;
        let lineItemUniqueId;
        let quantity;

        if (formData.get('warranty_variant_id')) {
          let warrantyVariantId = formData.get('warranty_variant_id');
          const warrantyVariantTitle = this.form.querySelector('input[name="warranty_variant_id"]:checked').getAttribute('data-warranty-variant-title');

          if (!warrantyVariantId.startsWith('default-')) {
            warrantyFormData = new FormData();
            warrantyFormData.set('id', warrantyVariantId);

            warrantyFormData.append('properties[_Associated Product ID]', formData.get('associated_product_id'));
          }

          if (warrantyVariantId.startsWith('default-')) {
            warrantyVariantId = warrantyVariantId.replace(/^default-/, '');
          }
          lineItemUniqueId = `line-${warrantyVariantId}`;

          formData.append('properties[Warranty]', warrantyVariantTitle);
          formData.append('properties[_product_warranty_id]', warrantyVariantId);
          formData.append('properties[_Line Item Unique ID]', lineItemUniqueId);
          if (cartItems) {
            quantity = cartItems.querySelector(`quantity-input input[data-index="${formData.get('line_item_index')}"]`).value;
            formData.set('quantity', quantity);
          }
        } else {
          const checkedWarranty = document.querySelector('.warranty-item input:checked');

          if (checkedWarranty) {
            const warrantyItem = checkedWarranty.closest('.warranty-item');
            const quickAddButton = warrantyItem?.querySelector('.quick-add .quick-add__submit');
            const warrantyForm = quickAddButton?.closest('form');

            if (warrantyForm) {
              warrantyFormData = new FormData(warrantyForm);
            }
          }
          quantity = parseInt(formData.get('quantity') || 1, 10);
        }

        if (warrantyFormData) {
          const warrantyId = warrantyFormData.get('id');
          lineItemUniqueId = lineItemUniqueId || `line-${warrantyId}`;

          formData.append('properties[_Line Item Unique ID]', lineItemUniqueId);
          formData.append('properties[_has_warranty_item]', 'true');

          warrantyFormData.append('properties[_Line Item Unique ID]', lineItemUniqueId);
          warrantyFormData.append('properties[_is_warranty_item]', 'true');
          warrantyFormData.set('quantity', quantity);
        } else {
          // fallback: no warranty selected
          formData.append('properties[_Line Item Unique ID]', `line-${formData.get('id')}`);
          formData.append('properties[_has_warranty_item]', 'false');
        }

        formData.append('properties[_warranty_products_handle]', formData.get('warranty_products_handle'));

        config.body = formData;

        const addMainProduct = () => {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                if (warrantyFormData) {
                  publish(PUB_SUB_EVENTS.warrantyUpdate, {
                    productVariantId: formData.get('id'),
                    warrantyVariantId: warrantyFormData.get('id'),
                    event: evt
                  })
                }
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                })
                .then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              }

                if (document.body.classList.contains('template-cart')) {
                    document.documentElement.classList.remove('overflow-hidden');

                    const cartItems = document.querySelector('.main-cart .main-cart-items');
                    if (cartItems) {
                        cartItems.style.removeProperty('z-index');
                    }
                }

              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        CartPerformance.measure("add:paint-updated-sections", () => {
                          this.cart.renderContents(response, !formData.get('warranty_variant_id'));
                        });
                      });
                    },
                    { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response, !formData.get('warranty_variant_id'));
                });
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (!formData.get('warranty_variant_id')) {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
              }

              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        };

        const addWarrantyProduct = () => {
          if (warrantyFormData) {
            const warrantyConfig = fetchConfig('javascript');
            warrantyConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete warrantyConfig.headers['Content-Type'];
            warrantyConfig.body = warrantyFormData;

            fetch(`${routes.cart_add_url}`, warrantyConfig)
                .then((warrantyResponse) => warrantyResponse.json())
                .then((warrantyResponse) => {
                  // 2. Add main product AFTER warranty
                  addMainProduct();
                })
                .catch((e) => {
                  console.error('Failed to add warranty:', e);
                  // Fallback: still try to add main product
                  addMainProduct();
                });
          } else {
            // Only add main product if no warranty
            addMainProduct();
          }
        }

        if (formData.get('line_item_index')) {
          cartItems.updateQuantity(formData.get('line_item_index'), 0, evt, null, null, false)
            .then(() => {
              // 1. Add warranty first
              addWarrantyProduct();
            });
        } else {
          // 1. Add warranty first
          addWarrantyProduct();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      validateRecipientForm(recipientForm) {
        let valid = true;

        const inputs = recipientForm.querySelectorAll('[data-validate]');

        inputs.forEach(input => {
          const rules = input.dataset.validate.split('|');
          const errorSpan = input.closest('.recipient-fields__field').querySelector('.error-message');

          errorSpan.textContent = '';
          errorSpan.closest('.form__message').classList.add('hidden');
      
          for (const rule of rules) {
            let message = '';
      
            if (rule === 'required' && !input.value.trim()) {
              message = 'This is a required field';
            }
            else if (rule === 'email') {
              const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!re.test(input.value.trim())) {
                message = 'Invalid email address';
              }
            }
            else if (rule.startsWith('match:')) {
              const targetName = rule.split(':')[1];
              const targetInput = this.querySelector(`[name="${targetName}"]`);
              if (targetInput && input.value.trim() !== targetInput.value.trim()) {
                message = 'Confirmation email does not match';
              }
            }
      
            if (message) {
              errorSpan.textContent = message;
              errorSpan.closest('.form__message').classList.remove('hidden');
              valid = false;
              break;
            }
          }
        });

        return valid;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
